const getTableRowFallback = data => {
    const { header } = data;

    if ('fallback' in header && typeof header.fallback === 'function') {
        return header.fallback(data);
    }

    return header.fallback;
};

export default getTableRowFallback;
